export const stringsKey = "IVRFlowTypeConfiguration";
export const englishStrings = {
	countryLabel: "Country",
	countryErrorMessage: "The Country field is required",
	descriptionLabel: "Description",
	descriptionErrorMessage: "The Description field is required",
	typeLabel: "Type",
	typeErrorMessage: "The Type field is required",
	countryListErrorMessage: "Error loading country list, Please try again",
};
